import { WEB_COMPONENT_SENSOR_INTUNE } from '../../../webcomponents.constants';
import { IntuneSensorComponent } from './component/IntuneSensorComponent';

export { IntuneSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_INTUNE, IntuneSensorComponent);
